<template>
    <div v-loading="displayLoading" class="col-lg-12">
        <div class="card  pt-20">
            <span class="chartTitle">{{title}}</span>

            <bar v-on:loader="loadingEvent" :range="dateRange" :localName="localName" :time="time" :url="url"
                 :addMonths="addMonths" :type="type" :type_from="type_from" :amountValue="amountValue"></bar>
        </div>
    </div>
</template>
<style>
    .el-date-editor {
        margin-left: 15px;
        margin-top: 15px;
    }
    .pt-20 {
        padding-top: 20px;
    }
    .chartTitle {
        margin-top: 20px;
        padding-left: 20px;
        font-weight: 600;
        color: #656565;
    }
</style>
<script>
  import Bar from './BarChart.js'

  export default {
    components: {
      Bar
    },
    props: {
      url: '',
      time: '',
      localName: '',
      title: '',
      addMonths: {
        default: false
      },
      type: {
        type: String,
        default: ''
      },
      type_from: {
        type: String,
        default: ''
      },
      dateRange: '',
      amountValue: {
        type: Boolean,
        default: false
      }
    },
    mounted () {
    },
    data () {
      return {
        displayLoading: false
      }
    },
    methods: {
      loadingEvent (load) {
        this.displayLoading = load
      }
    }
  }
</script>



// WEBPACK FOOTER //
// BarChart.vue?409d2e34